import { create } from 'zustand';

export interface ProfileData {
  firstName: string;
  lastName: string;
  jobTitle: string;
  department: string;
}

export interface OrgData {
  name: string;
}

interface OnboardingStepsState {
  currentStep: number;
  completedSteps: Set<string>;
  isLoading: boolean;
  profileData: ProfileData;
  orgData: OrgData;

  setCurrentStep: (step: number) => void;
  setCompletedSteps: (steps: Set<string>) => void;
  addCompletedStep: (stepId: string) => void;
  setIsLoading: (isLoading: boolean) => void;
  setProfileData: (data: Partial<ProfileData>) => void;
  setOrgData: (data: Partial<OrgData>) => void;
  reset: () => void;
}

export const useOnboardingStepsStore = create<OnboardingStepsState>((set) => ({
  currentStep: 0,
  completedSteps: new Set<string>(),
  isLoading: false,
  profileData: {
    firstName: '',
    lastName: '',
    jobTitle: '',
    department: '',
  },
  orgData: {
    name: '',
  },

  setCurrentStep: (step) => set({ currentStep: step }),
  setCompletedSteps: (steps) => set({ completedSteps: steps }),
  addCompletedStep: (stepId) =>
    set((state) => {
      const newSet = new Set(state.completedSteps);
      newSet.add(stepId);
      return { completedSteps: newSet };
    }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setProfileData: (data) =>
    set((state) => ({
      profileData: { ...state.profileData, ...data },
    })),
  setOrgData: (data) =>
    set((state) => ({
      orgData: { ...state.orgData, ...data },
    })),
  reset: () =>
    set({
      currentStep: 0,
      completedSteps: new Set<string>(),
      isLoading: false,
      profileData: { firstName: '', lastName: '', jobTitle: '', department: '' },
      orgData: { name: '' },
    }),
}));
